import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { NotificationFilter, NotificationTable, NotificationAlertModal } from "../components";
import * as notification from "../redux";

export const NotificationList = (props) => {

    const {
        notifications,
        pagination,
        changePage,
        loading,
        saving,
        saveError,
        extraProps,
        getNotifications,
        changeFilters,
        filters,
        updatingIds,
        toggleNotificationActive,
        saveNotification,
        dispatch_clearSaveError
    } = props;

    useEffect(() => {
        getNotifications();
    }, []);

    const [modal, setModal] = useState({ open: false, notification: null });
    const openModal = (notification = null) => setModal({ open: true, notification });
    const openModalCopy = notification => setModal({ open: true, notification: { ...notification, id: undefined, start_date: null, end_date: null } });
    const closeModal = () => {
        dispatch_clearSaveError();
        setModal({ open: false, notification: null });
    };

    const handleModalSave = (id, body) => {
        return saveNotification(id, body);
    };

    const baseOP = {
        className: "notification_list",
        breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Notification Management" }],
        extraProps,
        loading
    };

    const notificationTableOP = {
        list: notifications,
        pagination: {
            ...pagination,
            changePage
        },
        filters,
        updatingIds,
        onToggleActive: toggleNotificationActive,
        onEdit: openModal,
        onCopy: openModalCopy
    };

    const handleFilter = (filters) => {
        changeFilters(filters);
    };

    return (
        <>
            <NotificationAlertModal
                isOpen={modal.open}
                notification={modal.notification}
                onClose={closeModal}
                onSave={handleModalSave}
                saving={saving}
                saveError={saveError}
            />
            <Base {...baseOP}>
                <NotificationFilter onSubmit={handleFilter} onCreate={() => openModal()} />
                <NotificationTable {...notificationTableOP} />
            </Base>
        </>
        
    );
};

const mapStateToProps = store => ({
    notifications: notification.selectors.selectNotificationList(store),
    loading: notification.selectors.selectNotificationLoading(store),
    saving: notification.selectors.selectNotificationSaving(store),
    saveError: notification.selectors.selectNotificationSaveError(store),
    pagination: notification.selectors.selectPagination(store),
    filters: notification.selectors.selectFilters(store),
    updatingIds: notification.selectors.selectUpdatingIds(store)
});

const mapDispatchToProps = dispatch => ({
    getNotifications: () => dispatch(notification.actions.getNotifications()),
    changePage: page => dispatch(notification.actions.changePage(page)),
    changeFilters: filters => dispatch(notification.actions.updateFilter(filters)),
    toggleNotificationActive: (notification_id, is_active) =>
        dispatch(notification.actions.toggleNotificationActive(notification_id, is_active)),
    saveNotification: (id, body) => dispatch(notification.actions.saveNotification(id, body)),
    dispatch_clearSaveError: () => dispatch(notification.actions.clearSaveError())
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);